import { cacheService, orderCodeActions } from '../../services';
import { validateResponse } from '../../util/authenticatonValidation';

export const orderCodeDispatcher = dispatch => ( {
  find: ( givenCode, modelToLoad ) => {
    return cacheService( `from/${givenCode}/for` ).get( modelToLoad ).then( validateResponse( dispatch ) ).then( result => {
      return dispatch( { type: orderCodeActions.FOUND, code: givenCode, payload: result.data } ).then( () => result.data );
    } );
  },
  retrieve: ( givenCode, modelToLoad ) => {
    return cacheService( `configuration/from/${givenCode}/for` ).get( modelToLoad ).then( validateResponse( dispatch ) ).then( result => {
      return dispatch( { type: orderCodeActions.RETRIEVED, code: givenCode, payload: result.data } ).then( () => result.data );
    } );
  }
} );